const ALPHABET =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
// Rejection sampling: bytes above the largest multiple of 62 would bias the id.
const UNBIASED_BYTE_LIMIT = 256 - (256 % ALPHABET.length);

export const randomId = (length) => {
  let id = "";
  const bytes = new Uint8Array(length * 2);
  while (id.length < length) {
    window.crypto.getRandomValues(bytes);
    for (const byte of bytes) {
      if (byte < UNBIASED_BYTE_LIMIT && id.length < length) {
        id += ALPHABET[byte % ALPHABET.length];
      }
    }
  }
  return id;
};
